import _ from 'lodash';
import { ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { RedeemCoupon, SetPlan } from '../../features/data/data.actions';
import { selectCoupon, selectCouponError } from '../../features/data/data.selectors';
import { DomSanitizer } from '@angular/platform-browser';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-signup05',
  templateUrl: './signup05.component.html',
  styleUrls: ['./signup05.component.scss']
})
export class Signup05Component implements OnInit {
  destroyRef = inject(DestroyRef)
  public error$ = this.store.pipe(
    select(selectCouponError)
  );
  public error: string = null;

  public form: UntypedFormGroup = new UntypedFormGroup({
    code: new UntypedFormControl('', []),
    plans: new UntypedFormControl(null, [Validators.required]),
  });

  public planList = [{
    planType: 0,
    defaultInvoiceAmount: 0,
    invoiceAmount: 0,
    title: 'Silent Auctions and Online Donation',
    description: this.domSanitizer.bypassSecurityTrustHtml("Unlimited fundraising campaigns, Online and Silent auctions, unlimited donors, in-person donations through volunteers and more. <a target='_blank' style='color:#6E42FF;' href='https://w.paybee.io/pricing/'>See Details</a>")
  }, {
    planType: 1,
    defaultInvoiceAmount: 399,
    invoiceAmount: 399,
    title: 'Virtual Events',
    description: this.domSanitizer.bypassSecurityTrustHtml("Silent Auctions and Online Donation featues plus unlimited virtual events, 1-1 on-boarding session for upto 2 years. Renewal required after. <a target='_blank' style='color:#6E42FF;' href='https://w.paybee.io/pricing/'>See Details</a>")
  }, {
    planType: 2,
    defaultInvoiceAmount: 599,
    invoiceAmount: 599,
    title: 'In-Person or Hybrid',
    description: this.domSanitizer.bypassSecurityTrustHtml("All donation and silent auction plus in-person, virtual and hybrid event features. For upto 2 years. Renewal required after <a target='_blank' style='color:#6E42FF;' href='https://w.paybee.io/pricing/'>See Details</a>")
  }];
  public selected = this.planList[0];

  public coupons = [];

  public coupon$ = this.store.pipe(
    select(selectCoupon),
    map(coupon => _.isNull(coupon) ? {}: coupon)
  );

  public nextBtnClasses = {
    disabled: true
  };

  constructor(
    private store: Store,
    private domSanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.error$.pipe(
      filter(error => !_.isNull(error)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((error) => {
      const code = this.form.get('code');
      code.setErrors({ coupon: true });
      code.markAsTouched();

      this.error = error.errorMessage;
      this.cdr.markForCheck();
    });

    this.coupon$.pipe(
      filter(coupon => {
        const id = _.get(coupon, 'id', null);
        return !_.isNull(id);
      }),
      filter(({ id }) => {
        const { coupons } = this;
        return _.findIndex(coupons, value => {
          return value === id;
        }) < 0;
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(({ id, discountType, discountValue }) => {
      const { form } = this;
      this.planList = _.map(this.planList, ({ planType, defaultInvoiceAmount, invoiceAmount, title, description }) => {
        switch (discountType) {
          case 0:
            invoiceAmount = invoiceAmount > discountValue ? invoiceAmount - discountValue: 0;
            break;
          case 1:
            invoiceAmount = invoiceAmount - (invoiceAmount / 100) * discountValue;
            break;
        }
        return { planType, defaultInvoiceAmount, invoiceAmount, title, description };
      });
      this.coupons.push(id);
      if(form.value.plans) {
        this.selected = this.planList[form.value.plans];
        this.nextBtnClasses = { disabled: false };
      }
    });
  }

  onChange(value) {
    this.selected = this.planList[value];
    this.nextBtnClasses = { disabled: false };
    
    this.form.get('plans').setValue(value);
  }

  onRedeemCoupon() {
    const { form } = this;
    const code = form.get('code');
    if(code.valid) {
      this.store.dispatch({
        type: RedeemCoupon.type,
        payload: form.get('code').value
      });
      form.get('code').setValue('');
    }
  }

  getCouponErrorMessage() {
    const { form } = this;
    const code = form.get('code');

    if(!code.touched) return '';

    if(code.hasError('coupon')) {
      return this.error;
    }

    return '';
  }

  onNext() {
    this.store.dispatch({
      type: SetPlan.type,
      payload: this.selected
    });
  }
}
